module.exports = __webpack_public_path__ + "lk.svg?df0673653318852cda68aff2aae934a8";